import axios from '@axios'

export default {
    namespaced: true,
    state: {
        empleados:[],
        dataExcelEmp:[],
        estadoCuenta:[],
        cupoEmpleados:[],
        facturasEmpleados:[],
        cuentasxCobrar:[],
        comprobantesCobro:[],
        comprobanteGenerado:[],
        comprobantePDF:[],
        comprobanteResumido:[],
        comprobanteDetallado:[],
        comprobantesSeleccionados:[],

    },
    getters:{
        getEmpleados(state) {
            return state.empleados;
        },

        getExportarExcelEmpleados(state){
            return state.dataExcelEmp;
        },

        getEstadoCuentaColaborador(state){
            return state.estadoCuenta;
        },
        getCupoEmpleados(state) {
            return state.cupoEmpleados;
        },
        getFacturasColaborador(state) {
            return state.facturasEmpleados;
        },
        getCuentasxCobrar(state) {
            return state.cuentasxCobrar;
        },
        getComprobantesCobro(state) {
            return state.comprobantesCobro;
        },
        getComprobanteGenerado(state) {
            return state.comprobanteGenerado;
        },
        getComprobantePDF(state) {
            return state.comprobantePDF;
        },
        getComprobanteResumido(state) {
            return state.comprobanteResumido;
        },
        getComprobanteDetallado(state) {
            return state.comprobanteDetallado;
        },
        
        getComprobantesSeleccionados(state) {
            return state.comprobantesSeleccionados;
        },
        
        
    },
    mutations: {
        setEmpleados(state, empleados) {
            state.empleados = empleados;
        }, 
        setExportarExcelEmpleados(state,dataExcelEmp){
            state.dataExcelEmp=dataExcelEmp;
        }, 
        setEstadoCuentaColaborador(state,estadoCuenta){
            state.estadoCuenta=estadoCuenta;
        },
        setCupoEmpleados(state, cupoEmpleados) {
            state.cupoEmpleados = cupoEmpleados;
        }, 
        setFacturasColaborador(state, facturasEmpleados) {
            state.facturasEmpleados = facturasEmpleados;
        }, 
        setCuentasXCobrar(state, cuentasxCobrar) {
            state.cuentasxCobrar = cuentasxCobrar;
        },
        setComprobantesCobro(state, comprobantesCobro) {
            state.comprobantesCobro = comprobantesCobro;
        },
        setComprobanteGenerado(state, comprobanteGenerado) {
            state.comprobanteGenerado = comprobanteGenerado;
        },
        setDescargarComprobantePDF(state, comprobantePDF) {
            state.comprobantePDF = comprobantePDF;
        },
        setDescargarComprobanteResumido(state, comprobanteResumido) {
            state.comprobanteResumido = comprobanteResumido;
        },
        setDescargarComprobanteDetallado(state, comprobanteDetallado) {
            state.comprobanteDetallado = comprobanteDetallado;
        },
        
        setComprobantesSeleccionados(state, comprobantesSeleccionados) {
            state.comprobantesSeleccionados = comprobantesSeleccionados;
        },
    },

    actions:{
        fetchEmpleados({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/profremar/getEmpleados", {
                        params: data,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchAddEmpleado({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/profremar/addEmpleado", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchEditEmpleado({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/profremar/editEmpleado", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchImportarEmpleados({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/profremar/importarEmpleados", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchExportarExcelEmpleados({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/profremar/getDataExcelColaboradores", {
                        params: data,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchEstadoCuentaColaborador({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/profremar/getEstadoCuentaColaborador", {
                        params: data,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchCuposEmpleados({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/profremar/getCuposEmpleados", {
                        params: data,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchFacturasColaborador({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/profremar/getFacturasColaborador", {
                        params: data,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },  
        fetchCuentasxCobrar({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/profremar/getCuentasXCobrar", {
                        params: data,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchGenerarComprobanteCobro({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/profremar/generarComprobanteCobro", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchComprobantesCobro({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/profremar/getComprobantesCobro", {
                        params: data,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchCargarComprobanteGenerado({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/profremar/getComprobanteGenerado", {
                        params: data,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        
        fetchDownloadComprobantePDF({ commit }, data) {
            return new Promise((resolve, reject) => {
                const link = "/api/auth/profremar/descargarComprobantePDF";
                axios({
                    method: "post",
                    url: link,
                    responseType: "blob",
                    data,
                })
                    .then((response) => {
                        commit("setDescargarComprobantePDF", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        fetchDownloadComprobanteResumido({ commit }, data) {
            return new Promise((resolve, reject) => {
                const link = "/api/auth/profremar/descargarComprobanteResumido";
                axios({
                    method: "post",
                    url: link,
                    responseType: "blob",
                    data,
                })
                    .then((response) => {
                        commit("setDescargarComprobanteResumido", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        fetchDownloadComprobanteDetallado({ commit }, data) {
            return new Promise((resolve, reject) => {
                const link = "/api/auth/profremar/descargarComprobanteDetallado";
                axios({
                    method: "post",
                    url: link,
                    responseType: "blob",
                    data,
                })
                    .then((response) => {
                        commit("setDescargarComprobanteDetallado", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },


        async descargarPlantillaEmpleados({ commit }) {
            return (await axios.get('/api/auth/profremar/getPlantillaEmpleado', {
              responseType: 'arraybuffer',
            })).data
          },


          fetchCargarComprobantesSeleccionados({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/profremar/getComprobantesSeleccionados", {
                        params: data,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchGenerarAbono({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/profremar/addAbonos", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },


    }
}